<template>
  <Modal :title="title" :showModal="showModal" class="edit-carrier-account-form" @submit="submit">
    <template v-slot:body>
      <component :is="modal" :config="modalConfig()" @close="$emit('close', $event)"></component>
    </template>
  </Modal>
</template>

<script>
import Event from '@/helper/event.js'

export default {
  mixins: [Event],
  data() {
    return {
      modal: 'Black',
      platform: null
    }
  },
  computed: {
    title() {
      return 'Edit Carrier Account'
    },
    action() {
      return 'edit'
    },
    storeId() {
      return this.config?.storeId
    },
    accountId() {
      return this.config?.data?._id
    },
    getUri() {
      return `carrier-account/get/${this.accountId}`
    },
    submitUri() {
      return `carrier-account/update/${this.accountId}`
    },
    data() {
      return this.store.getter('', {})
    }
  },
  created() {
    this.store.commit('', {})
  },
  mounted() {
    this.$emitter.on('Modal.CarrierAccount.Edit.DownloadLatestCalculationFile', this.downloadLatestCalculationFile)
  },
  unmounted() {
    this.$emitter.off('Modal.CarrierAccount.Edit.DownloadLatestCalculationFile', this.downloadLatestCalculationFile)
  },
  methods: {
    modalConfig() {
      return {
        action: this.action,
        storeId: this.storeId,
        accountId: this.accountId
      }
    },
    setUpData(rawData) {
      if (rawData.status == 'success') {
        this.platform = rawData.data.platform || ''
        let platform = _.pascalCase(this.platform)
        let action = _.pascalCase(this.action)
        let modal = `${platform}.CarrierAccount.${action}`
        if (this.$options.components[modal] == undefined) {
          this.$options.components[modal] = this.$util.requireOrNull(`/platforms/${platform}/CarrierAccount/Modal/${action}.vue`)
        }
        if (!_.isUndefined(rawData.data.platform) && this.$options.components[modal] !== null) {
          this.showModal = true
          rawData.data.meta = Object.assign({}, rawData.data.meta)
          this.store.commit('', rawData.data)
          this.modal = modal
        } else {
          this.$emit('close')
          this.$util.notify({
            text: 'Platforms not supported!',
            status: 'error'
          })
        }
      }
    },
    downloadLatestCalculationFile() {
      this.$util
        .post(
          `/carrier-account/extra/${this.accountId}`,
          {
            action: 'download-latest-calculation-file',
            platform: this.platform
          },
          null
        )
        .then((response) => {
          if (response.status == 'success') {
            this.$util.downloadFile({
              url: response.url
            })
          }
        })
    },
    submit() {
      this.$emitter.emit('Modal.CarrierAccount.Edit.Submit', this.data)
    }
  },
  props: {
    config: Object
  }
}
</script>
